<template>
  <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :onClick="handleClick">
    <v-tooltip :showTitle="false" dataKey="item*percent"/>
    <v-axis/>
    <v-legend dataKey="item"/>
    <!--<v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig"/>-->
    <v-pie position="percent" :color="item" :v-style="pieStyle" :label="labelConfig"/>
   <!-- <v-pie position="percent" :color="['item',['#EE82EE','#0000CD','#5F9EA0','#FFA500','#CD5C5C']]" :v-style="pieStyle" :label="labelConfig"/>-->
    <v-coord type="theta" :radius="0.75" :innerRadius="0.6"/>
    <v-guide :type="guideOpts.type" :position="guideOpts.position"         :content="guideOpts.content" :v-style="guideOpts.style" />
  </v-chart>
</template>

<script>
  //可自定义饼图颜色
  const DataSet = require('@antv/data-set')
  import { ChartEventMixins } from './mixins/ChartMixins'

  export default {
    name: 'Pie',
    mixins: [ChartEventMixins],
    props: {
      title: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 454
      },
      dataSource: {
        type: Array,
        default: () => [
        ]
      },
      colorChange : {
        type: Boolean,
        default: false,
      },

      midText: {
        type: Number,
        default:0,
      }

    },
    data() {
      return {
        scale: [{
          dataKey: 'percent',
          min: 0,
          formatter: '.0%'
        }],
        pieStyle: {
          stroke: '#fff',
          lineWidth: 1
        },
      /* labelConfig: ['percent', {
          formatter: (val, item) => {
            return item.point.item + ': ' + val
          }
        }],*/
        labelConfig: ['percent', {
          offset: -30,
          textStyle: {
            rotate: 0,
            textAlign: 'center',
            shadowBlur: 2,
            fill: 'white',
            shadowColor: 'rgba(0, 0, 0, .45)'
          }
        }],

        guideOpts:{},

        //自定义饼图颜色
        item: ['item',['#10BA21','#F6C022','#DA0A1B']],
      }
    },
    computed: {
      data() {
        if (this.colorChange) {
          this.item = ['item',['#3BA1FF','#8400FF','#FBD437','#F2637B']]
        }

        console.log('midText : ',this.midText)
        this.guideOpts = {  type: 'text',  position: ['50%', '50%'],  content: '总人数 ' + this.midText + ' 人',  style: {    lineHeight: '240px',    fontSize: '15',    fill: '#262626',    textAlign: 'center'  }}

        let dv = new DataSet.View().source(this.dataSource)
        // 计算数据百分比
        dv.transform({
          type: 'percent',
          field: 'count',
          dimension: 'item',
          as: 'percent'
        })
        return dv.rows
      }
    },

  /*  created() {
      console.log('midText : ',this.midText)
      this.guideOpts = {  type: 'text',  position: ['50%', '50%'],  content: '总人数 ' + this.midText + ' 人',  style: {    lineHeight: '240px',    fontSize: '15',    fill: '#262626',    textAlign: 'center'  }}
    }*/
  }
</script>